import { render, staticRenderFns } from "./RanksDropDown.vue?vue&type=template&id=28bffb58&scoped=true&"
import script from "./RanksDropDown.vue?vue&type=script&lang=js&"
export * from "./RanksDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bffb58",
  null
  
)

export default component.exports